import React from 'react';
import CURRENCY from 'utils/currency';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'components/ui/tooltip';
import { Icon } from 'components/ui/icon';

interface LabeledAmountDisplayProps {
  method?: string;
  amount: number | undefined;
  label: string;
  tooltipText?: string;
  caption?: string;
}

const formatCurrency = (amount: number | undefined): string => {
  return CURRENCY.convertToMainUnit(amount) ?? '$00.00';
};

const LabeledAmountDisplay: React.FC<LabeledAmountDisplayProps> = ({
  method,
  amount,
  label,
  tooltipText,
  caption,
}) => {
  return (
    <>
      <div>
        <div className="flex items-center" style={{ gap: '4px' }}>
          <div>{label}</div>
          {tooltipText && method && (
            <span className="inline-flex items-center justify-center">
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Icon name="info" size={16} style={{ color: '#808690' }} />
                  </TooltipTrigger>
                  <TooltipContent side="right" className="max-w-xs">
                    {tooltipText}
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </span>
          )}
        </div>
        {caption && <div className="text-xs font-normal italic">{caption}</div>}
      </div>
      <div>{formatCurrency(amount)}</div>
    </>
  );
};

export default LabeledAmountDisplay;
